const services = [
  {
    id: 1,
    title: "Diseño y Construcción de Piscinas",
    desc: "En Insercom nos dedicamos a la construcción, remodelación y reparación de piscinas. Contamos con un grupo de expertos profesionales que te asesorarán desde el inicio del proyecto.",
    icon: "ri-water-flash-fill",
    img: "https://public.readdy.ai/ai/img_res/ca43b6e8cbbd8b0b9f3863997c8afe66.jpg",
  },
  {
    id: 2,
    title: "Fabricación e Instalación de Hidromasajes",
    desc: "Diseño, fabricación, instalación y venta de hidromasajes de exterior e interior para su máximo confort y relajación.",
    icon: "ri-drop-fill",
    img: "https://readdy.ai/api/search-image?query=luxury%20jacuzzi%20hot%20tub%20installation%20outdoor%20garden%20terrace%20modern%20home%20spa%20jets%20bubbles%20relaxation&width=500&height=340&seq=svc02&orientation=landscape",
  },
  {
    id: 3,
    title: "Mantenimiento de Piscinas",
    desc: "Tenemos una amplia trayectoria profesional en el cuidado de tu piscina e hidromasaje todo el año garantizando el perfecto funcionamiento.",
    icon: "ri-tools-fill",
    img: "https://readdy.ai/api/search-image?query=pool%20maintenance%20technician%20cleaning%20swimming%20pool%20with%20professional%20equipment%20robotic%20cleaner%20blue%20water&width=500&height=340&seq=svc03&orientation=landscape",
  },
  {
    id: 4,
    title: "Verjas Perimetrales",
    desc: "Contamos con una variedad de diseños de verjas perimetrales para piscinas de distintas alturas y modelos, cuidando siempre de la seguridad de los tuyos.",
    icon: "ri-shield-check-fill",
    img: "https://readdy.ai/api/search-image?query=pool%20safety%20perimeter%20fence%20metal%20railing%20around%20swimming%20pool%20modern%20home%20outdoor%20safety%20barrier&width=500&height=340&seq=svc04&orientation=landscape",
  },
  {
    id: 5,
    title: "Covers",
    desc: "Covers para piscina e hidromasajes ideales para proteger tus proyectos durante todo el año con materiales de alta durabilidad.",
    icon: "ri-sun-fill",
    img: "https://readdy.ai/api/search-image?query=swimming%20pool%20cover%20thermal%20protection%20automatic%20pool%20cover%20retractable%20safety%20cover%20modern%20garden&width=500&height=340&seq=svc05&orientation=landscape",
  },
  {
    id: 6,
    title: "Igualas",
    desc: "Contrata nuestras visitas técnicas y mantenimiento acordados mediante un contrato de iguala mensual para garantizar el cuidado constante.",
    icon: "ri-calendar-check-fill",
    img: "https://readdy.ai/api/search-image?query=pool%20maintenance%20service%20technician%20worker%20checking%20water%20chemistry%20testing%20pool%20chemicals%20professional%20service&width=500&height=340&seq=svc06&orientation=landscape",
  },
];

export default function Services() {
  return (
    <section id="servicios" className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-16">
          <p className="text-teal-600 text-xs font-bold tracking-[0.3em] uppercase mb-3">Lo que ofrecemos</p>
          <h2 className="text-4xl font-black text-gray-900 tracking-widest">SERVICIOS</h2>
          <div className="w-12 h-1 bg-teal-500 mx-auto mt-4 rounded-full" />
        </div>

        {/* Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((svc) => (
            <div
              key={svc.id}
              className="bg-white rounded-2xl overflow-hidden group hover:-translate-y-1 transition-all duration-300"
            >
              <div className="relative h-48 overflow-hidden">
                <img
                  src={svc.img}
                  alt={svc.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-teal-900/40 to-transparent" />
                <div className="absolute top-4 left-4 w-9 h-9 bg-teal-500 rounded-full flex items-center justify-center">
                  <i className={`${svc.icon} text-white text-base`} />
                </div>
              </div>
              <div className="p-6">
                <h3 className="text-teal-700 font-black text-sm uppercase tracking-wide mb-3">{svc.title}</h3>
                <p className="text-gray-500 text-sm leading-relaxed">{svc.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
